import { DocumentTitleContext } from "@app/shared/DocumentTitleContext";
import PageFooter from "@app/shared/PageFooter";
import { FC, useContext, useEffect } from "react";

interface PageProps {
  children?: React.ReactNode;
  className?: string;
  documentTitle: string;
}

const Page: FC<PageProps> = (props: PageProps) => {
  const titleContext = useContext(DocumentTitleContext);

  useEffect(() => {
    // don't want any empty strings or undefineds in here
    if (!!props.documentTitle) {
      titleContext.setTitle(`${props.documentTitle} - Quest Analytics®`);
    }

    return () => {
      titleContext.setTitle("Quest Analytics®");
    }
  }, [props.documentTitle]);

  const classes = `page ${props.className || ""}`;

  return (
    <>
      <div className={classes}>
        {props.children}
        <PageFooter />
      </div>
    </>
  );
}

export default Page;